export const dataLayerPush = (data: any) => {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer?.push(data);
};

export const dataLayerPushPageView = (lastUrl: string|undefined, dlObject: Record<string, any>|undefined = {}) => {
    const dl = Object.assign({}, {pageType: 'other'}, dlObject);
    dataLayerPush(dl);

    dataLayerPush({
        event: 'ga.page',
        location: window.location.href,
        path: window.location.pathname,
        title: document.title,
        referrer: lastUrl ? lastUrl : document.referrer,
    });
}
